export class Chart {

    pass: number;
    fail: number;
    inconclusive: number;
    notRun: number;
    blocked: number;
    skipped: number;
}
